import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";

import Table from "./../../components/general/Table/Table";
import TruckForm from "./../../components/page/drive/TruckForm/TruckForm";
import TruckRouteHistoryModal from "./../../components/page/drive/TruckRouteHistoryModal/TruckRouteHistoryModal";
import Loading from "../../components/wrapper/Loading/Loading";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class EditVendorTruckPage extends Component {
  state = {
    truckId: null,
    eventsLog: [],
    historyLog: [],
    modalShow: false,
    modalData: {},
    isLoading: false
  };

  truckEventsHeaders = ["id", "Date", "Event", "Description"];

  historyLogHeaders = ["id", "Campaign Name", "Track Only", "Start Date", "End Date"];
  historyLogButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let log = this.state.historyLog.find((item) => item[0] === id);
        let data = {
          id: log[0],
          name: log[1],
          tracking: log[2],
          startDate: log[3],
          endDate: log[4] !== "-" ? log[4] : moment().format("MM/DD/YYYY")
        };
        this.setState({
          modalData: data,
          modalShow: true
        });
      }
    }
  ];

  componentDidMount = async () => {
    let truckId = this.props.match.params.id;
    // get history log
    this.setState({
      isLoading: true
    })
    let res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/${truckId}/history`, { withCredentials: true });
    if (res.status === 200 && res.data.truck && res.data.truck.history) {
      console.log(res.data.truck);
      let firstDatetime = moment(res.data.truck.first_datetime).format("MM/DD/YYYY");
      let gpsProvider = res.data.truck.gps_provider ? res.data.truck.gps_provider : "Linxup";
      let history = [[truckId, "", true, firstDatetime, "-"]];

      res.data.truck.history
        .filter((item) => item.name)
        .map((item, index) => {
          if (index === 0) {
            history[0] = history[0][4] = moment(item.start_date).utc().format("MM/DD/YYYY");
          }
          history.push([
            item.truck_id,
            item.name,
            "",
            moment(item.start_date).utc().format("MM/DD/YYYY"),
            moment(item.end_date).utc().format("MM/DD/YYYY")
          ]);
        });

      this.setState({
        truckId: truckId,
        historyLog: history,
        eventsLog: [[null, "9/27/2020", "Sample truck event", "A truck event occured"]],
        isLoading: false
      });
    }
  };

  toggleModal = () => {
    this.setState({
      modalShow: false,
      modalData: {}
    });
  };

  updateTruck = async (truck) => {
    try {
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/truck/${this.state.truckId}`, truck, config);
      if (res.status === 200 && res.data.updated_truck && res.data.updated_truck[0].truck_id) {
        //alert("Truck was updated");
        //this.props.history.push(`/dashboard/admin/drive/vendor/edit/${truck.vendor_id}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <Fragment>
        <Loading loading={this.state.isLoading} label="Loading Truck..."></Loading>
        <Helmet>
          <title>Boxi Admin | Vendor Truck</title>
        </Helmet>
        <Row className="mb-4">
          <Col xs={12}>
            <TruckForm id={this.state.truckId} update={this.updateTruck} edit />
          </Col>
        </Row>
        {/* <Row className="mb-4">
          <Col xs={12}>
            <Table
              title="Truck Events Log"
              id="turck-events-log-table"
              headers={this.truckEventsHeaders}
              data={this.state.eventsLog}
              colors={["#787ff6", "#7bd5f5"]}
            />
          </Col>
        </Row> */}
        <Row>
          <Col xs={12}>
            <Table
              title="Truck History Log"
              id="truck-history-log-table"
              headers={this.historyLogHeaders}
              data={this.state.historyLog}
              buttons={this.historyLogButtons}
            />
          </Col>
        </Row>
        <TruckRouteHistoryModal toggleModal={this.toggleModal} show={this.state.modalShow} data={this.state.modalData} />
      </Fragment>
    );
  }
}

export default withRouter(EditVendorTruckPage);
